var IconButton            = require("app/ui/IconButton"),
    PageBackgroundSupport = require("app/ui/PageBackgroundSupport"),
    PopupLayout           = require("app/AppLayout/PopupLayout"),
    ScrollerPopup         = require("app/ui/ScrollerPopup"),
    ImageOptimizerSupport = require("app/ui/ImageOptimizerSupport"),
    config                = require("app/config"),
    frameThrottle         = require("enyo-perf/utils").frameThrottle,
    kind                  = require("enyo/kind");

require("./IsAdultPopup.less");
require("app/theme/styles/popups/ScrollerPopup--bordered.less");
require("app/theme/IconButton--neutral.less");

module.exports = kind(/** @lends  app.Auth.IsAdultPopup.prototype */ {

    /**
     * @private
     */
    name: "app.Auth.IsAdultPopup",

    /**
     * @private
     */
    kind: ScrollerPopup,

    /**
     * @private
     */
    mixins: [
        ImageOptimizerSupport,
        PageBackgroundSupport
    ],

    /**
     * @private
     */
    layoutKind: PopupLayout,

    /**
     * @private
     */
    layoutOptions: {
        alignment: "fullLayout"
    },

    /**
     * @private
     */
    classes: "app-auth-is-adult-popup",

    /**
     * @public
     */
    theme: "bordered",

    /**
     * No close button for this one.
     *
     * @public
     */
    showCloseButton: false,

    /**
     * @private
     */
    components: [{
        name:       "message",
        classes:    "app-auth-is-adult-popup__message",
        components: [{
            name:       "content",
            classes:    "app-auth-is-adult-popup__content",
            components: [{
                name:    "title",
                classes: "app-auth-is-adult-popup__title",
                tag:     "h2"
            }, {
                name:    "body",
                classes: "app-auth-is-adult-popup__body",
                tag:     "p"
            }, {
                classes:    "app-auth-is-adult-popup__buttons",
                components: [{
                    name:    "yepButton",
                    kind:    IconButton,
                    classes: "app-auth-is-adult-popup__yep-button",
                    ontap:   "onYepButtonTap"
                }, {
                    name:    "nopeButton",
                    kind:    IconButton,
                    classes: "app-auth-is-adult-popup__nope-button",
                    ontap:   "onNopeButtonTap"
                }]
            }, {
                name:    "note",
                classes: "app-auth-is-adult-popup__note",
                tag:     "p"
            }]
        }]
    }],

    /**
     * @private
     */
    handlers: {
        onYepButtonTap:  "onYepButtonTap",
        onNopeButtonTap: "onNopeButtonTap"
    },

    /**
     * @method
     * @private
     */
    initComponents: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.$.yepButton.set("theme", "neutral");
            this.$.yepButton.set("icon", null);
            this.$.nopeButton.set("theme", "neutral");
            this.$.nopeButton.set("icon", null);
        };
    }),

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @public
     */
    update: function() {
        var i18nService = this.app.$.i18nService,
            $yepButton  = this.$.yepButton,
            $nopeButton = this.$.nopeButton,
            note        = i18nService.getString("app.Auth.IsAdultPopup.body");

        this.$.title.set("content", i18nService.getString("app.Auth.IsAdultPopup.title"));
        this.$.body.set("content", i18nService.getString("app.Auth.IsAdultPopup.body"));
        $yepButton.set("caption", i18nService.getString("app.Auth.IsAdultPopup.IsAdultButton.caption"));
        $yepButton.set("tooltip", i18nService.getString("app.Auth.IsAdultPopup.IsAdultButton.tooltip"));
        $nopeButton.set("caption", i18nService.getString("app.Auth.IsAdultPopup.IsNotAdultButton.caption"));
        $nopeButton.set("tooltip", i18nService.getString("app.Auth.IsAdultPopup.IsNotAdultButton.tooltip"));

        if (note) {
            this.$.note.set("content", i18nService.getString("app.Auth.IsAdultPopup.note"));
        }
    },

    /**
     * @private
     */
    onYepButtonTap: function() {
        config.ottApi.useLocalStorage && localStorage.setItem("ottVisitorIsAdult", "true");
        this.close();
    },

    /**
     * @public
     */
    onNopeButtonTap: function() {
        config.ottApi.useLocalStorage && localStorage.setItem("ottVisitorIsAdult", "false");
        this.close();
    }

});
